import React, { useState } from "react";
import volcano from "./logovolcano.png";
import "./contact.css";
import { db } from "./base";
import { useForm } from "react-hook-form";
import Aos from "aos";
import "aos/dist/aos.css";
function Contact() {
  React.useEffect(() => {
    Aos.init();
  }, []);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");

  const [loader, setLoader] = useState(false);
  const { handleSubmit, register, errors } = useForm();
  const onSubmit = (values) => {
    console.log(values);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleName = (e) => {
    console.log(e);
    setName(e.target.value);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };

  const clearInput = () => {
    setEmail("");
    setMessage("");
    setName("");
  };
  const checkSubmit = (e) => {
    e.preventDefault();
    setLoader(true);

    db.collection("client")
      .add({
        email: email,
        name: name,
        message: message,
      })
      .then(() => {
        setLoader(false);
        alert(
          "Ton message a été envoyé avec succés , on va venir vers vous dès que possible👍"
        );
        clearInput();
      })
      .catch((error) => {
        alert(error);
        setLoader(false);
      });
    setName("");
    setEmail("");
    setMessage("");
  };
  return (
    <div class="container1" id="contact">
      <div className="temoignage-head">
        <h1>Contactez nous 💬</h1>
      </div>
      <div class="row3 " data-aos="fade-up" data-aos-duration="500">
        <div class="column2">
          <div class="card2">
            <div class="flex">
              <img class="image" src={volcano} />
            </div>
          </div>
        </div>
        <div class="column2">
          <form onSubmit={checkSubmit}>
            <label for="fname">Votre Nom :</label>
            <input
              class="input"
              type="text"
              id="Name"
              name="Name"
              onChange={handleName}
              placeholder="Votre Nom.."
            />
            <label for="country">Votre email :</label>
            <input
              class="input"
              type="email"
              name="Email"
              id="Email"
              {...register("message", {
                required: "Required",

                pattern: {
                  value: " [a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$",
                  message: "invalid email address",
                },
              })}
              onChange={handleEmail}
              placeholder=" Votre email "
            />

            <label for="subject">Sujet de votre message :</label>
            <textarea
              style={{ height: "170px" }}
              class="textarea"
              id="Sujet"
              name="Sujet"
              placeholder="Dites nous ce que vous voulez ..."
              onChange={handleMessage}
            ></textarea>
            <button
              className="btn"
              type="submit"
              value="submit"
              name="submit"
              id="envoyer"
              onSubmit={handleSubmit(onSubmit)}
              disabled={!message && !email && !name}
            >
              Envoyer
            </button>
          </form>
        </div>
      </div>
      <hr />
      <footer class="footer2">
        <div class="container4">
          <div class="row4">
            <div class="footer2-col">
              <h4>Volcano</h4>
              <ul>
                <li>
                  <a href="#apropos">A propos de nous</a>
                </li>
                <li>
                  <a href="#menu">Nos services</a>
                </li>
                <li>
                  <a href="#">Confidentialité</a>
                </li>
              </ul>
            </div>

            <div class="footer2-col">
              <h4>Nos Avantages</h4>

              <img
                src="https://assets.beinsports.com/beIN_SPORTS.png"
                width="150px"
                height="30px"
              />

              <img
                src="https://thumbs.dreamstime.com/z/noircissez-la-viande-halal-arrondie-de-signe-non-permise-de-manger-et-boire-pour-l-islam-94577133.jpg"
                width="80px"
                height="70px"
                style={{ borderRadius: "80%" }}
              />

              <img
                src="https://lourdiegourmandise.com/wp-content/uploads/2020/01/Uber_eats.jpg"
                width="80px"
                height="70px"
                style={{ borderRadius: "80%" }}
              />
            </div>
            <div class="footer2-col">
              <h4>Suivez nous</h4>
              <div class="social-links">
                <a
                  href="https://www.facebook.com/VOLCANO.LEMANS"
                  target="_blank"
                >
                  <i class="fab fa-facebook-f"></i>
                </a>
                <a href="#">
                  <i class="fab fa-whatsapp"></i>
                </a>
                <a href="#">
                  <i class="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="copyright">
        {" "}
        © Copyright 2022 volcano-tech Tous les droits résérvés.
      </div>
    </div>
  );
}

export default Contact;
